/**
* Steps Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Steps Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'steps-scroller',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      if ( window.innerWidth < 1024 ) {
        if ( !$( '.steps-scroller__slider' ).hasClass( 'slick-initialized' ) ) {
          $( '.steps-scroller__slider' ).slick( {
            dots: false,
            fade: true,
            arrows: true,
            prevArrow: $( '.steps-scroller' ).find( '.prev-slide' )[0],
            nextArrow: $( '.steps-scroller' ).find( '.next-slide' )[0],
            slidesToShow: 1,
          } );
        }
      }

      adjustButtonPosition();

      if ( window.innerWidth >= 1024 ) {
        $( '.steps-scroller' ).each( function( key, component ) {
          const docStyle = getComputedStyle( document.documentElement );
          const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
          const topOffset = parseInt( navHeight );

          const originalPanelHeight = $( this ).find( '.steps-scroller__panel' ).height();
          const speed = 2;
          const panelHeight = originalPanelHeight * ( 1 + 0.25 * speed );
          const panelsCount = $( this ).find( '.steps-scroller__panel' ).length;

          $( component ).height(
              $( component ).find( '.steps-scroller__panel' ).height() * ( panelsCount + speed )
          );

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              pin: $( component ).find( '.steps-scroller__panels' )[0],
              start: 'top ' + topOffset,
              end: 'bottom bottom',
              scrub: 1,
            },
          } );

          $( component )
              .find( '.steps-scroller__panel' )
              .each( function( panelKey, panel ) {
                const startPosition = panelHeight * panelKey;
                const tl = gsap.timeline( {
                  scrollTrigger: {
                    trigger: panel,
                    start: startPosition + ' top',
                    end: '+=' + panelHeight,
                    onEnter: ( self ) => {
                      const thisContent = $( panel ).find( '.steps-scroller__content' );
                      $( thisContent ).addClass( 'is-really-active' );
                      $( component )
                          .find( '.steps-scroller__content' )
                          .not( thisContent )
                          .removeClass( 'is-really-active' );
                    },
                    onEnterBack: ( self ) => {
                      const thisContent = $( panel ).find( '.steps-scroller__content' );
                      $( thisContent ).addClass( 'is-really-active' );
                      $( component )
                          .find( '.steps-scroller__content' )
                          .not( thisContent )
                          .removeClass( 'is-really-active' );
                    },
                    scrub: 1,
                  },
                } );
              } );
        } );
      }
    },

    finalize: function() {},
  };

  function adjustButtonPosition() {
    let maxHeight = 0;

    $( '.steps-scroller__slide' ).each( function() {
      const imageHeight = $( this ).find( '.steps-scroller__slider-image' ).outerHeight();
      if ( imageHeight > maxHeight ) {
        maxHeight = imageHeight;
      }
    } );

    $( '.steps-scroller .slider-buttons' ).css( 'margin-bottom', `${maxHeight + 12}px` );
  }

  function handleResize() {
    if ( window.innerWidth < 1024 ) {
      if ( !$( '.steps-scroller__slider' ).hasClass( 'slick-initialized' ) ) {
        $( '.steps-scroller__slider' ).slick( {
          dots: false,
          fade: true,
          arrows: true,
          prevArrow: $( '.steps-scroller' ).find( '.prev-slide' )[0],
          nextArrow: $( '.steps-scroller' ).find( '.next-slide' )[0],
          slidesToShow: 1,
        } );
      }
    } else {
      ScrollTrigger.getAll().forEach( ( trigger ) => {
        if ( trigger ) {
          trigger.enabled = false;
        }
      } );
    }

    if ( window.innerWidth >= 1024 ) {
      ScrollTrigger.getAll().forEach( ( trigger ) => {
        if ( trigger ) {
          trigger.enabled = true;
        }
      } );
    }

    adjustButtonPosition();
  }

  app.registerComponent( 'steps-scroller', COMPONENT );

  window.addEventListener( 'resize', handleResize );

  $( document ).ready( function() {
    COMPONENT.init();

    if ( window.innerWidth >= 1024 ) {
      const navHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) ) || 0;
      window.scrollTo( {
        top: 0,
        behavior: 'auto',
      } );
    }
  } );
} )( app );
